var styles = {"skeleton":"index-module_skeleton__-UHKw","themed":"index-module_themed__9zUAo"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
